import { Bounds } from "../../../engine/space/bounds";
import { RNG } from "rot-js";
import buildMinSpanTree from "./buildMinSpanTree";
import { addLoops, compareRooms, GraphNode } from "./graphUtils";
import { pruneLeafs, raiseLeafs } from "./leafUtils";

export const BSPGenerate = (rng: typeof RNG, width: number, height: number) => {
  const graph = graphRooms(rng, makeInitialRooms(rng, 8, width, height));
  const mstgraph = buildMinSpanTree(graph, 0);
  raiseLeafs(mstgraph);
  addLoops(rng, 0.45, graph, mstgraph);
  pruneLeafs(rng, 1, mstgraph);
  console.log(mstgraph);
  return mstgraph;
};

const makeInitialRooms = (
  rng: typeof RNG,
  maxDepth: number,
  width: number,
  height: number
) => {
  const result: Bounds[] = [];
  const container = { x: 0, y: 0, w: width, h: height };
  const queue: [Bounds, number][] = [[container, 0]];

  let next: [Bounds, number] | undefined, area, depth, l, r;
  // eslint-disable-next-line no-cond-assign
  while ((next = queue.pop())) {
    [area, depth] = next;
    if (depth <= maxDepth && (8 <= area.w || 8 <= area.h)) {
      [l, r] = splitArea(rng, area);
      queue.push([l, depth + 1], [r, depth + 1]);
    } else {
      result.push(area);
    }
  }
  return result;
};

const splitArea = (rng: typeof RNG, bounds: Bounds) => {
  let l, r;
  if (8 <= bounds.w && 0.45 < bounds.w / bounds.h) {
    const min = Math.floor(bounds.w * 0.45);
    const max = Math.ceil(bounds.w * 0.55);
    l = {
      x: bounds.x,
      y: bounds.y,
      w: rng.getUniformInt(min, max),
      h: bounds.h,
    };
    r = { x: bounds.x + l.w, y: bounds.y, w: bounds.w - l.w, h: bounds.h };
  } else {
    const min = Math.floor(bounds.h * 0.45);
    const max = Math.ceil(bounds.h * 0.55);
    l = {
      x: bounds.x,
      y: bounds.y,
      w: bounds.w,
      h: rng.getUniformInt(min, max),
    };
    r = { x: bounds.x, y: bounds.y + l.h, w: bounds.w, h: bounds.h - l.h };
  }
  return [l, r] as const;
};

const graphRooms = (rng: typeof RNG, rooms: Bounds[]) => {
  const result: Map<number, GraphNode> = new Map();

  let iRoom, jRoom, iResult, jResult;
  for (let i = 0; i < rooms.length; i++) {
    iRoom = rooms[i];
    iResult =
      result.get(i) ||
      result
        .set(i, { bounds: iRoom, adj: [], weight: rng.getUniform(), z: 1 })
        .get(i);
    for (let j = i + 1; j < rooms.length; j++) {
      jRoom = rooms[j];
      if (compareRooms(iRoom, jRoom)) {
        jResult =
          result.get(j) ||
          result
            .set(j, { bounds: jRoom, adj: [], weight: rng.getUniform(), z: 1 })
            .get(j);
        iResult?.adj.push(j);
        jResult?.adj.push(i);
      }
    }
  }
  return result;
};
